import { createSlice } from '@reduxjs/toolkit'
import { alertsTexts } from 'locale/es'
import AlertsService from 'services/AlertsService'
import { appendFullNames, appendFullNames2 } from 'utils/HelperFunctions'
import { toast } from './notificationReducer'

function mappedData(data) {
  return appendFullNames2(data.map(alert => {
    return {
      id: alert.id,
      message: alert.message,
      creationDate: alert.created,
      viewed: alert.viewed,
      firstName: alert.relatedTo.firstName,
      lastName: alert.relatedTo.lastName
    }
  }))
}

const initialState = { data: [], totalCount: null, unreadAlerts: null, loading: false, error: null }

const allAlertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setAllAlerts(state, action) {
      const { data, totalCount } = action.payload

      return { ...state, data: mappedData(data), totalCount, loading: false, error: null }
    },
    appendAlerts(state, action) {
      const { data } = action.payload

      const filteredAlerts = data.filter(incomingAlert =>
        state.data.every(alert => incomingAlert.id !== alert.id)
      )

      return { ...state, data: [...state.data, ...mappedData(filteredAlerts)], loading: false, error: null }
    },
    removeAlert(state, action) {
      const newDataState = state.data.filter((alert) => alert.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null }
    },
    updateAlert(state, action) {
      const { data } = action.payload

      const mappedUpdatedEntry = mappedData([data])

      const updatedAlerts = state.data.map((alert) =>
        alert.id !== data.id ? alert : mappedUpdatedEntry[0]
      )

      return { ...state, data: updatedAlerts, loading: false, error: null }

    },
    setUnreadAlerts(state, action) {
      return { ...state, unreadAlerts: action.payload }
    },
    setAlertsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setAlertsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetAlertsState(state, action) {
      return initialState
    }
  }
})

export const { setAllAlerts, setUnreadAlerts, appendAlerts, removeAlert, updateAlert, setAlertsLoading, setAlertsError, resetAlertsState } = allAlertsSlice.actions

export const initializeAlerts = (centerId, page, size) => {
  return async (dispatch) => {
    try {
      dispatch(setAlertsLoading());

      const { data, headers } = await AlertsService.get(centerId, page, size)

      dispatch(setAllAlerts({ data, totalCount: parseInt(headers["x-total-count"]) }))
    }
    catch (error) {
      console.error(error)
      dispatch(setAlertsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(alertsTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const getUnreadAlertsAction = (centerId) => {
  return async (dispatch) => {
    try {
      const { data } = await AlertsService.getUnread(centerId)
      dispatch(setUnreadAlerts(data))
    }
    catch (error) {
      console.error(error)
      dispatch(setAlertsError({ message: error.message, status: error.response?.status }));
    }
  }
}

export const fetchMoreAlertsAction = (centerId, page, size) => {
  return async (dispatch) => {
    try {
      dispatch(setAlertsLoading());

      const { data } = await AlertsService.get(centerId, page, size)
      dispatch(appendAlerts({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setAlertsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(alertsTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const updateAlertAction = ({ id, viewed }) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await AlertsService.update(id, { id, viewed })

      const newUnreadAlertsState = getState().alerts.unreadAlerts + (viewed ? -1 : 1)

      dispatch(updateAlert({ data }))
      dispatch(toast(alertsTexts.VIEWED, 'success'))
      dispatch(setUnreadAlerts(newUnreadAlertsState))
    } catch (error) {
      console.error(error)
      dispatch(setAlertsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(alertsTexts.VIEWED_ERROR, 'error'))
    }
  }
}

export const deleteAlertAction = (id) => {
  return async (dispatch) => {
    try {
      await AlertsService.remove(id)
      dispatch(removeAlert(id))
      dispatch(toast(alertsTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setAlertsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(alertsTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default allAlertsSlice.reducer